

import {Button, Chip, ListItem, ListItemSecondaryAction, ListItemText, MenuItem, Stack, Typography} from "@mui/material";
import Card from "../Components/Card";
import DataViewer from "../Components/DataViewer";
import Page from "../Components/Page";
import {useState} from "react";
import {Popup} from "../Components/Popup";
import Form from "../Components/Form";
import InputGroup from "../Components/FormComponents/InputGroup";
import Dropdown from "../Components/FormComponents/Dropdown";
import SlateEditor from "../Components/Slate";
import {Descendant} from "slate";
import FirebaseQuery from "../Util/firebaseQuery";
import ListMaker from "../Components/FormComponents/ListMaker";
import {where} from "firebase/firestore";
import {camelCaseToNormal, capitaliseWords, convertDate} from "../Util/util";
import {subjectColours} from "..";
import FileDropzone from "../Components/FileDropzone";
import {storage} from "../Util/firebaseConfig";
import {ref, uploadBytes} from "firebase/storage";


export type Article = {
    title: string,
    date: string,
    type: string,
    subject: "biology"|"chemistry"|"physics"|"maths"|"health"|"tech",
    author: string,
    subtopic?: string,
    topic?: string,
    summary: string,
    mainSummary: string,
    body: Descendant[]
};


export default function Dashboard() {
    const [upload, setUpload] = useState(false);
    const [uploadKW, setUploadKW] = useState<{keyword: string, definition: string}[]>();

    const firebaseQuery = new FirebaseQuery();

    const uploadArticle = async (e: Partial<Article>&{icon?: any}) => {
        const article = {...e};
        delete article.icon;
        console.log("ICON", e.icon[0]);

        const articleDoc = await firebaseQuery.add(["articles"], article);

        const storageRef = ref(storage, `articles/${articleDoc.id}.png`);
        await uploadBytes(storageRef, e.icon[0]);
        uploadKW?.map(async (kw) => {
            const existing = await firebaseQuery.getCount(["keywords"], [where("keyword", "==", kw.keyword)]);
            if (!existing) {
                await firebaseQuery.add(["keywords"], kw);
            }
            return;
        });
    };

    return (<Page grid>
        <DataViewer grid xs={12} md={8} title={"Articles"} data={[{path: ["articles"]}]} listViewRenderer={(k, v: Article) =>
            <ListItem sx={{borderLeft: `3px solid ${subjectColours[v.subject]}`}} key={k} id={k}>
                <ListItemText
                    primary={v.title}
                    secondary={capitaliseWords(camelCaseToNormal(v.author)) + " | " + convertDate(v.date, "visual")}
                />
                <ListItemSecondaryAction>
                    <Stack spacing={1}>
                        <Chip label={capitaliseWords(v.type)}/>
                        <Chip label={capitaliseWords(v.subject)}/>
                    </Stack>
                </ListItemSecondaryAction>
            </ListItem>}/>
        <Card grid xs={12} md={4} title={"Overview"} secondaryTitle={<Button onClick={() => setUpload(true)}>Upload</Button>}>

        </Card>
        <Popup title={"Upload Article"} maxWidth={"md"} fullWidth open={upload} onClose={() => setUpload(false)}>
            <Form onSubmit={uploadArticle}>
                <InputGroup required name={"title"} label={"title"}/>
                <InputGroup required name={"date"} type={"date"} label={"Date"}/>
                <FileDropzone name="icon" accept="image/png" label="Article icon (png)"/>
                <Dropdown required name={"author"} label={"author"}>
                    <MenuItem value={"Heath Martin"}>Heath</MenuItem>
                    <MenuItem value={"Thomas Barton"}>Tom</MenuItem>
                    <MenuItem value={"Sadie McGrane"}>Sadie</MenuItem>
                    <MenuItem value={"Joanna Bras-Goldberg"}>Joanna</MenuItem>
                    <MenuItem value={"Isabelle Gallier-Birt"}>Isabelle</MenuItem>
                    <MenuItem value={"Nicole Szekeres-Tapp"}>Nicole</MenuItem>
                    <MenuItem value={"Jade Williams"}>Jade</MenuItem>

                </Dropdown>
                <Dropdown required name={"type"} label={"type"}>
                    <MenuItem value={"learn"}>Learn</MenuItem>
                    <MenuItem value={"news"}>News</MenuItem>
                </Dropdown>
                <Dropdown required name={"subject"} label={"subject"}>
                    <MenuItem value={"physics"}>Physics</MenuItem>
                    <MenuItem value={"health"}>Health</MenuItem>
                    <MenuItem value={"biology"}>Biology</MenuItem>
                    <MenuItem value={"chemistry"}>Chemistry</MenuItem>
                    <MenuItem value={"maths"}>Maths</MenuItem>
                    <MenuItem value={"tech"}>Tech</MenuItem>
                </Dropdown>
                <InputGroup name={"topic"} label={"topic"}/>
                <InputGroup name={"subtopic"} label={"subtopic"}/>
                <InputGroup required name={"summary"} label={"summary"} multiline minRows={4}/>
                <InputGroup name={"mainSummary"} label={"mainSummary"} multiline minRows={4}/>
                <Typography>Add the main text into the field below. For keywords, <strong><u>bold and underline</u></strong>. For headings, click "1" or "2". Make sure only one is pressed or the text will be too big.</Typography>
                <SlateEditor name={"body"}/>
                <Typography variant="h6">Keywords</Typography>
                <ListMaker label="Keywords" onChange={(e) => setUploadKW(e as any)} name="keywords" multipleInputs>
                    <InputGroup name={"keyword"} label={"Keyword"}/>
                    <InputGroup name={"definition"} label={"Definition"}/>
                </ListMaker>
            </Form>
        </Popup>
    </Page>);
}
